import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class ConnectionLivestockService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getConnection(): Observable<any[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/stableLoads/connections').pipe(
      map((response) => {
        return response;
      })
    );
  }

  connect(cuaa, id, connectionType): Observable<any[]> {
    const body = {
      cuaa,
      externalUserIdentifier: id,
      connectionType,
    };
    return this.http
      .post<any[]>(this.apiBaseUrl + 'api/private/v2/stableLoads/connections', body)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  disconnect(id): Observable<any[]> {
    return this.http
      .put<
        any[]
      >(this.apiBaseUrl + 'api/private/v1/stableLoads/connections/' + id + '/disconnect', {})
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
